export default __webpack_public_path__ + "static/tab3Img-859df3716c612ffb72eddfee6476f1f7.png";